import { defineMessages, FormattedMessage } from 'react-intl';
import Link from '@atlaskit/link';
import { xcss, Box } from '@atlaskit/primitives';
const messages = defineMessages({
  agreementHeader: {
    id: 'oauth.partnercentral.bestPracticesHeader',
    defaultMessage: 'By accepting this app, you:',
    description: 'The header for oath legal terms',
  },
  agreementBulletTwo: {
    id: 'oauth.partnercentral.bestPracticesBulletTwo',
    defaultMessage: 'Agree to the {privacyPolicyLink} and {termsOfUseLink}',
    description:
      'Second oath terms of agreement. The privacyPolicyLink and termsOfUseLink are replaced with actual links in the UI.',
  },
  privacyPolicy: {
    id: 'oauth.partnercentral.privacyPolicy',
    defaultMessage: 'privacy policy',
    description: 'Text for the privacy policy link',
  },
  termsOfUse: {
    id: 'oauth.partnercentral.termsOfUse',
    defaultMessage: 'terms of use',
    description: 'Text for the terms of use link',
  },
});

const disclaimerStyle = xcss({
  color: 'color.text.subtle',
  font: 'font.body.small',
});

const LegalDisclaimer: React.FC = () => {
  const privacyPolicyLink = (
    <Link href="https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers">
      <FormattedMessage {...messages.privacyPolicy} />
    </Link>
  );

  const termsOfUseLink = (
    <Link href="https://www.atlassian.com/legal/atlassian-customer-agreement#intro">
      <FormattedMessage {...messages.termsOfUse} />
    </Link>
  );

  return (
    <Box xcss={disclaimerStyle}>
      <FormattedMessage {...messages.agreementHeader} tagName="p" />
      <ul>
        <li>
          <FormattedMessage
            {...messages.agreementBulletTwo}
            values={{
              privacyPolicyLink,
              termsOfUseLink,
            }}
          />
        </li>
      </ul>
    </Box>
  );
};

export default LegalDisclaimer;
